import WrongNetworkModal from './WrongNetworkModal';
import WrongNetworkModalContainer from './WrongNetworkModalContainer';

export {WrongNetworkModalContainer};
export default WrongNetworkModal;